import * as React from 'react';
import {
    Typography,
    Container,
    Box, Grid, Stack
} from '@mui/material';
import AccessibleIcon from '@mui/icons-material/Accessible';
import {ImageTextBlock, Map} from "../index";
import {styled} from "@mui/material/styles";
import EuroIcon from '@mui/icons-material/Euro';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import DirectionsSubwayFilledIcon from '@mui/icons-material/DirectionsSubwayFilled';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import axios from "../../axios";
import {Link} from "react-router-dom";
import {useDarkMode} from "../darkMode/hook/useDarkMode";

const Img = styled('img')({
    top: '33px',
    left: '34px',
    display: 'block',
    width: '132px',
    height: 'auto',
    minHeight : '88px',
    borderRadius: '5px',

});

const ImgDirection =  styled('img')({
    width: '355px',
    height: 'auto',
    minHeight : '389px',
    marginTop : '30px',
    boxShadow: '10px 20px #DD809D'
});



const EstablishmentInformation = ({establishment, markers, latitude, longitude}) => {
    const openGoogleMap = () => {
        window.open("https://www.google.com/maps/search/?api=1&query="+latitude+","+longitude, "_blank")
    }
    const {mode} = useDarkMode();
    return (
        <div>
            <Container className={'container'}>
                <div id={"anchor1"}></div>
                <Typography component={'div'} id={"allowedPublicContainer"}>
                    {establishment.relations.public.length > 0 ?
                        <div className={"allowedParent"}>
                            <Typography variant={"h3"} style={{color : mode.settings.textColor3, marginBottom : '30px'}}>
                                Public concerné
                            </Typography>
                            <div className={"allowedPublicBox"} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
                                {establishment.relations.public.map((content) => (
                                    <div style={{width:'auto', backgroundColor: mode.settings.cardBackgroundColor}} className={"allowedPublicChild"}>
                                        <AccessibleIcon role="img" aria-label="Public concerné de l'établissement" style={{fontSize:40, color:'#C72B5C'}}></AccessibleIcon>
                                        <Typography variant={'subtitle1'} style={{color : mode.settings.textColor3}}>
                                            {content.label.text}
                                        </Typography>
                                    </div>
                                ))}
                            </div>
                        </div>: <div></div>}
                    {establishment.relations.specificity.length > 0 ?
                        <div className={"allowedParent"}>
                            <Typography variant={"h3"} style={{color : mode.settings.textColor3, marginBottom : '30px'}}>
                                Spécificités
                            </Typography>
                            <div className={"allowedPublicBox"} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
                                {establishment.relations.specificity.map((content) => (
                                    <div style={{minWidth:'auto', backgroundColor: mode.settings.cardBackgroundColor}} className={"allowedPublicChild"}>
                                        <AccessibleIcon role="img" aria-label="Spécificités de l'établissement" style={{fontSize:40, color:'#C72B5C'}}></AccessibleIcon>
                                        <Typography variant={'subtitle1'} style={{color : mode.settings.textColor3}}>
                                            {content.name.text}
                                        </Typography>
                                    </div>
                                ))}
                            </div>
                        </div>: <div></div>}
                </Typography>
                <br/>
                {establishment.relations.image_text.length > 0 ?
                    <Box bgcolor={mode.settings.cardBackgroundColor} py={3} style={{border:'1px solid rgba(38, 50, 56, 0.3)', borderRadius:5}}>
                        <Container className={'container'}>
                            <ImageTextBlock image_text={establishment.relations.image_text[0]}></ImageTextBlock>
                        </Container>
                    </Box>: <div></div>}
                <br/>
                {Object.keys(establishment.relations.bloc_6_images).length !== 0 ?
                    <div className={"littleBoxContainer"}>
                        {
                            establishment.relations.bloc_6_images.relations.card_image_text_number.map((card) => (
                                <div className={"littleBox"} style={{backgroundColor: mode.settings.cardBackgroundColor}}>
                                    <Img alt={card.image.alternativeText} src={`${axios.defaults.apiBaseURL}/${card.image.uri}`} />
                                    <Typography sx={{textAlign : 'center'}} variant={"subtitle10"} color={mode.settings.textColor9}>
                                        {card.text.text}
                                    </Typography>
                                    <Typography variant={"h2"} color={mode.settings.textColor9}>
                                        {card.number.value}
                                    </Typography>
                                </div>
                            ))
                        }
                    </div>: <div></div>}
                <br/>
            </Container>




            <div id={"anchor2"}></div>
            {establishment.relations.tarif.length > 0 ?
            <div className={"tarifContainer"}>
                <Container maxWidth={"lg"}>
                    <Typography variant={'subtitle18'} sx={{textAlign : 'center', color : 'white', display : 'block'}}>
                        <EuroIcon role="img" aria-label="Prix de la préstation" id={"tarifIcon"}></EuroIcon> {establishment.relations.tarif[0].title.text}
                    </Typography>
                    <Typography variant={'subtitle10'} sx={{color : 'white'}}>
                        À partir de {establishment.relations.tarif[0].price.value} € TTC
                    </Typography>
                    <Typography variant={'subtitle10'} sx={{color : 'white'}}>
                        {establishment.relations.tarif[0].text.text}
                    </Typography>
                </Container>
            </div>: <div></div>}
            {establishment.relations.mot_direction.length > 0 ?
            <div className={"directionWordContainer"} style={{backgroundColor : mode.settings.cardBackgroundColor}}>
                <Container className={'container'}>
                    <Box maxWidth="lg" className={"directionWordContent"}>
                        <ImgDirection alt={establishment.relations.mot_direction[0].image.alternativeText} src={`${axios.defaults.apiBaseURL}/${establishment.relations.mot_direction[0].image.uri}`}/>
                        <div className={"directionWordText"}>
                            <Typography variant={"h3"} style={{color:mode.settings.textColor6}}>{establishment.relations.mot_direction[0].title.text}</Typography>
                            <br/>
                            <Typography className={"dixHuitPx"} style={{marginBottom:50, color:mode.settings.textColor3}}>
                                {establishment.relations.mot_direction[0].text.text}
                            </Typography>
                            <Typography variant={'subtitle10'} sx={{color:mode.settings.textColor3, position : 'absolute', right : 0 , bottom : 0}}>
                                {establishment.relations.mot_direction[0].name.text} - {establishment.relations.mot_direction[0].poste.text}
                            </Typography>
                        </div>
                    </Box>
                </Container>

            </div>: <div></div>}
            <Container className={'container'}>
                {Object.keys(establishment.relations.bloc_3_composant).length !== 0 ?
                <Box maxWidth="lg" className={"boxBordered"}>
                    {
                        establishment.relations.bloc_3_composant.relations.card_title_text.map((content) => (
                            <div className={"boxBorderedChild"} style={{backgroundColor : mode.settings.cardBackgroundColor}}>
                                <Typography variant={"h3"} style={{color : mode.settings.textColor3}}>{content.title.text}</Typography>
                                <div className={"boxBorderedLine"}></div>
                                <Typography variant={"subtitle3_1"} style={{marginTop:15, color : mode.settings.textColor3}}>
                                    {content.text.text}
                                </Typography>
                                <div className={"boxBorderedEndLine"}></div>
                            </div>
                        ))
                    }
                </Box>: <div></div>}
                <div id={"anchor3"}></div>
                <Box maxWidth="lg" style={{marginTop:30,marginBottom:30}}>
                    <Typography variant={"h3"} style={{color : mode.settings.textColor3}}>Se rendre à l’établissement </Typography>
                </Box>
                <Box maxWidth="lg" className={"boxAddress"}>
                    <div className={"boxCurrentAddress"}>
                        <LocationOnIcon role="img" aria-label="Emplacement de l'établissement" style={{marginRight :9}}></LocationOnIcon>
                        <Stack direction={"row"} spacing={1}>
                            <Typography
                                className={"phoneLink"}
                                onClick={openGoogleMap}
                                aria-label={"Ouvrir l'établissement dans google Map"}
                                sx={{cursor:'pointer'}}
                            >{establishment.road.text}</Typography>
                            <Typography
                                className={"phoneLink"}
                                onClick={openGoogleMap}
                                aria-label={"Ouvrir l'établissement dans google Map"}
                                sx={{cursor:'pointer'}}
                            >{establishment.zipcode.text+" "+establishment.city.text}</Typography>
                        </Stack>
                    </div>
                    <div className={"boxAddressDetail"}>
                        {
                            establishment.by_car.text == "" ? <div></div> :
                            <div className={"boxAddressBox"}>
                                <DirectionsCarIcon role="img" aria-label="Aller à l'établissement en voiture" style={{fontSize :40, marginRight :20}}></DirectionsCarIcon>
                                <div className={"boxAddressText"}>
                                    <div className={"boxAddressTextTitle"}>En voiture</div>
                                    <Typography variant={"subtitle3"}>
                                        {establishment.by_car.text}
                                    </Typography>
                                </div>
                            </div>
                        }
                        {
                            establishment.by_transport.text == "" ? <div></div> :
                            <div className={"boxAddressBox"}>
                                <DirectionsSubwayFilledIcon role="img" aria-label="Aller à l'établissement en transport en commun" style={{fontSize :40, marginRight :20}}></DirectionsSubwayFilledIcon>
                                <div className={"boxAddressText"}>
                                    <div className={"boxAddressTextTitle"}>En transport en commun</div>
                                    <Typography variant={"subtitle3"}>
                                        {establishment.by_transport.text}
                                    </Typography>
                                </div>
                            </div>
                        }
                        {
                            establishment.by_other.text == "" ? <div></div> :
                            <div className={"boxAddressBox"}>
                                <LocalShippingIcon role="img" aria-label="Aller à l'établissement d'une autre façon"  style={{fontSize :40, marginRight :20}}></LocalShippingIcon>
                                <div className={"boxAddressText"}>
                                    <div className={"boxAddressTextTitle"}>Autre</div>
                                    <Typography variant={"subtitle3"}>
                                        {establishment.by_other.text}
                                    </Typography>
                                </div>
                            </div>
                        }
                    </div>
                </Box>
                <div style={{maxWidth: 1211,marginRight: "auto",marginLeft: "auto"}}>
                    <Map markers={markers} />
                </div>
            </Container>
        </div>
    )
}

export default EstablishmentInformation;
